import React from "react";
import * as SC from "./Tooltip.styles";

interface TooltipProps {
  children: React.ReactNode;
  content: JSX.Element;
}

export const Tooltip = ({ children, content }: TooltipProps) => {
  return (
    <SC.TooltipCard>
      <SC.TooltipText>{children}</SC.TooltipText>
      <SC.TooltipBox>{content}</SC.TooltipBox>
    </SC.TooltipCard>
  );
};
